import { Component, Input, OnInit } from '@angular/core';
import { VetsInfo } from '../vetsInfo.model';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
})
export class ReviewsComponent implements OnInit {
  @Input() vet: VetsInfo;
  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
  }

  onClose() {
    this.modalCtrl.dismiss();
  }

  isLong(text?: string): boolean {
    return (text?.length || 0) > 220;
  }

  toggleExpand(review: any) {
    review.expanded = !review.expanded;
  }

  trackByAuthor = (_: number, r: any) => r.author_name || r.time || r.id;
  fallbackSrc = 'assets/img/avatar-default.png';
  useFallback(e: Event) { (e.target as HTMLImageElement).src = this.fallbackSrc; }

}
